/**
 * pdf上传
 */
import React, {Component} from 'react';
import {Modal, Input, message} from "antd";
import UploadWall from "../../../../components/upload/UploadWall";
import {Scrollbars} from 'react-custom-scrollbars';
import OtherNormalFileItem from "../../../../components/upload/fileItem/OtherNormalFileItem";

export default class PDFUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uploadFileList: [],
            pdfWidth: '100%',
            pdfHeight: 600
        };
    }

    handlePdfSizeChange = (e, dimension) => {
        const value = e.target.value;
        const inputRegex = /^(\d+(\.\d{0,2})?%?)?$/;
        if (!inputRegex.test(value)) {
            // 非法输入，不做处理或进行错误提示
            return;
        }
        this.setState({[dimension]: value}, () => {
            this.props.sizeCall && this.props.sizeCall(dimension, value);
        });
    };

    onChange = (info) => {
        const {file,fileList} = info;
        const isPdf = file.type === "pdf" || file.type === "PDF" || file.type === "application/pdf";
        if (!isPdf) {
           return message.error('仅支持PDF文件!');
        }
        // 去重逻辑
        let uniqueFileList = fileList.reduce((accumulator, currentFile) => {
            let isDuplicate = accumulator && accumulator.some((existingFile) => {
                if (existingFile?.response?.data?.md5 && currentFile?.response?.data?.md5) {
                    return existingFile.response.data.md5 === currentFile.response.data.md5
                }
            });
            if (!isDuplicate) {
                return [...accumulator, currentFile];
            }else {
                message.warn('已存在该资源')
            }
            return accumulator;
        }, []);
        uniqueFileList = uniqueFileList.map(item => {
            // 取决于需要什么数据填入fileList
            if (item.uid === info.file.uid) {
                if (info.file.response && info.file.response.data) {
                    //分片上传是走的自己封装的接口 所以返回值只有data
                    //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                    info.file.response = {...info.file.response.data, ...info.file.response};
                    item.response = info.file.response;
                }
                item.ext = info.file.response && info.file.response.suffix;
                item.url = info.file.response && info.file.response.path;
                item.path = info.file.response && info.file.response.path;
                item.name = info.file.response && info.file.response.name;
                item.type = "pdf";
                item.isChunk = true;
                item.status = info.file.status;
            }
            return item;
        });
        this.setState({fileList: uniqueFileList}, () => {
            this.props.fileListCall && this.props.fileListCall(this.state.fileList)
        });
    };

    handleRemove = file => {
        let fileList = this.state.fileList.filter(item =>item.uid!==file.uid || item.type!=="pdf");
        this.setState({
            fileList
        }, () => {
            this.props.fileListCall && this.props.fileListCall(this.state.fileList)
        });
    };
    upload = () => {
        const {fileList} = this.state;
        return (
            <UploadWall
                ref={uploadWall => this.uploadWall = uploadWall}
                showUploadDisplayBtn={true}
                accept={".pdf"}
                multiple={true}
                action="/storage/uploadFile"
                fileList={fileList}
                style={{padding: 'unset'}}
                icons={["delete"]}
                fileItemComponent={OtherNormalFileItem}
                uploadBtnName={"点击上传"}
                onChange={this.onChange}
                onRemove={this.handleRemove}
                onPreview={this.handlePreview}
            />
        )
    };

    render() {
        const {pdfUpload, handleOk, handleCancel} = this.props;
        const {uploadFileList, pdfWidth, pdfHeight, isInvalid} = this.state;
        return (<Modal
            title="本地上传"
            visible={pdfUpload}
            onCancel={handleCancel}
            width={958}
            onOk={() => {
                handleOk()
                // handleOk(fileList)
            }}
            maskClosable={false}
        >
            <div className="interval">
                <div>
                    <div style={{marginBottom: 10}}>
                        <span style={{marginRight: 10}}>宽度：</span>
                        <Input id="pdfWidth"
                               type="text"
                               placeholder="请输入宽度"
                               value={pdfWidth}
                               onChange={(e) => this.handlePdfSizeChange(e, 'pdfWidth')}
                               style={{width: 240, marginRight: 10}}/>
                        <span style={{marginRight: 10}}>高度：</span>
                        <Input type="text"
                               id="pdfHeight"
                               placeholder="请输入高度"
                               value={pdfHeight}
                               onChange={(e) => this.handlePdfSizeChange(e, 'pdfHeight')}
                               style={{width: 240}}/>
                    </div>
                    <div>
                        <Scrollbars style={{marginTop: 10}} autoHeight={true}
                                    autoHeightMax={document.body.clientHeight - 500}>
                            {this.upload()}
                        </Scrollbars>
                    </div>
                </div>
            </div>
        </Modal>)
    };
}